import {useEffect, useState} from 'react'
import {Button, Center} from '@mantine/core'
import {Modal} from 'react-bootstrap'
import {changeTextCapital, sortEmailsDescending} from '../../../_metronic/helpers/AssetHelpers'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import {useAuth} from '../../modules/auth'
import {
  cancelSubmit,
  deleteBand,
  getBand,
  getBandById,
  handleInputChange,
  handleSubmit,
  valibandLevelForm,
} from './BandFunctions'
import {Toolbar1} from '../../../_metronic/layout/components/toolbar/Toolbar1'
import InputErrorBox from '../../components/InputErrorBox'

type BandDetails = {
  id: string
  bandName: string
  bandDescription: string
  minCtc: string
  maxCtc: string
}

const Band = () => {
  const [band, setBand] = useState([
    {
      id: '',
      bandName: '',
      bandDescription: '',
      minCtc: '',
      maxCtc: '',
    },
  ])
  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  const {currentUser} = useAuth()
  const isAdminUser = currentUser?.isAdmin || false
  const initialState = {bandName: '', bandDescription: '', minCtc: '', maxCtc: ''}
  const [inputField, setInputField] = useState(initialState)
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [selectedBand, setSelectedBand] = useState<BandDetails | null>(null)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      getBand((fetchedEmails) => {
        const sortedEmails = sortEmailsDescending(fetchedEmails)
        setBand(sortedEmails)
        setAPIStatus({
          loading: false,
          error: null,
          submitLoading: false,
        })
      }, setAPIStatus)
      setIsAddUserModalOpen(false)
      setIsEditModalOpen(false)
    }
    return () => {
      mounted = false
    }
  }, [])

  const handleClose = () => {
    setIsAddUserModalOpen(false)
  }

  const handleDescriptionClick = (band) => {
    setSelectedBand(band)
  }

  const handleModalClose = () => {
    setSelectedBand(null)
  }

  if (APIStatus.loading) {
    return <div>Loading...</div>
  }

  if (APIStatus.error) {
    return <div>Error: {APIStatus.error}</div>
  }

  return (
    <>
      <Toolbar1 />

      <Modal
        show={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        animation={false}
        backdrop='static'
        onRequestClose={handleClose}
        centered
      >
        {/* begin::modal header--add band */}
        <div className='modal-header'>
          <h2 className='fw-bolder'>Add Band</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              handleClose()
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label className='fs-6 fw-semibold mb-2'>Band Name</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                className='form-control'
                type='text'
                placeholder='Band Name'
                name='bandName'
                value={inputField.bandName}
                onChange={(event) => handleInputChange(event, setInputField, inputField)}
              />
              <InputErrorBox Message={inputError.bandName} />
            </div>
            <div className='col-md-6 mb-5'>
              <label className='fs-6 fw-semibold mb-2'>Band Description</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                className='form-control'
                type='text'
                placeholder='Band Description'
                name='bandDescription'
                value={inputField.bandDescription}
                onChange={(event) => handleInputChange(event, setInputField, inputField)}
              />
              {<InputErrorBox Message={inputError.bandDescription} />}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label className='fs-6 fw-semibold mb-2'>Min. Annual Package</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                className='form-control'
                type='text'
                placeholder='Min CTC'
                name='minCtc'
                value={inputField.minCtc}
                onChange={(event) => handleInputChange(event, setInputField, inputField)}
              />
              {<InputErrorBox Message={inputError.minCtc} />}
            </div>
            <div className='col-md-6 mb-5'>
              <label className='fs-6 fw-semibold mb-2'>Max. Annual Package</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                className='form-control'
                type='text'
                placeholder='Max CTC'
                name='maxCtc'
                value={inputField.maxCtc}
                onChange={(event) => handleInputChange(event, setInputField, inputField)}
              />
              {<InputErrorBox Message={inputError.maxCtc} />}
            </div>
          </div>
          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
                setInputError('')
              }}
              type='button'
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{marginLeft: '15px'}}
            >
              Clear
            </Button>
            <Button
              loaderPosition='center'
              type='submit'
              className='btn btn-primary btn-sm font-weight-bold h-10'
              loading={SubmitAPIStatus.loading}
              onClick={() => {
                handleSubmit(
                  inputField,
                  getBand,
                  setBand,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  setInputError,
                  valibandLevelForm,
                  setSubmitAPIStatus,
                  setIsAddUserModalOpen
                )
              }}
            >
              {editId !== null ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </Modal>
      {/* //end of the form */}

      {/* begin:: Description Modal */}
      <Modal show={selectedBand !== null} onHide={handleModalClose} animation={false} centered>
        <div className='modal-header'>
          <h2 className='fw-bolder'>Band Description</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            style={{cursor: 'pointer'}}
            onClick={handleModalClose}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='modal-body'>
          {selectedBand && (
            <>
              <p>
                {selectedBand.bandDescription}
              </p>
            </>
          )}
        </div>
      </Modal>
      {/* end:: Description Modal */}

      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          {/* begin:: card */}
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin:: card header */}
            <div className='card-header'>
              <div className='card-title'>Bands</div>
              <div
                className='d-flex mt-4 justify-content-end'
                data-kt-user-table-toolbar='base'
                style={{height: '3rem'}}
              >
                {/* Begin::Add User button */}
                <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={() => {
                    setIsAddUserModalOpen(true)
                  }}
                >
                  Add Band
                </button>
                {/* end::Add user button */}
              </div>
            </div>
            {/* begin:: card body */}
            <div className='card-body'>
              {APIStatus.submitLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : APIStatus.error != null ? (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{APIStatus.error}</div>
                </div>
              ) : (
                <div className='table-responsive'>
                  <table
                    className='table 
  table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                  >
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>
                          {changeTextCapital('Sr.No')}
                        </th>
                        <th className='pl-1 flex-start text-muted' style={{minWidth: '150px'}}>
                          {changeTextCapital('Band Name')}
                        </th>
                        <th className='pl-1 flex-start text-muted' style={{minWidth: '300px'}}>
                          {changeTextCapital('Description')}
                        </th>
                        <th className='pl-1 flex-start text-muted' style={{minWidth: '100px'}}>
                          {changeTextCapital('Min. Annual Package')}
                        </th>
                        <th className='pl-1 flex-start text-muted' style={{minWidth: '100px'}}>
                          {changeTextCapital('Max. Annual Package')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '100px'}}>
                          {changeTextCapital('Actions')}
                        </th>
                      </tr>
                    </thead>

                    {band?.length > 0 ? (
                      <tbody className='text-gray-800 fw-semibold text-left'>
                        {band.map((obj, index) => (
                          <tr
                            className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
                            key={obj?.id ?? '-'}
                          >
                            <td className='text-center'>{index + 1}</td>
                            <td className='flex-start'>{obj?.bandName ?? '-'}</td>
                            <td
                          className='flex-start'
                          style={{
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '300px'
                          }}
                          onClick={() => handleDescriptionClick(obj)}
                        >
                          {obj.bandDescription}
                        </td>
                            <td className='text-end'>{obj?.minCtc ?? '-'}</td>
                            <td className='text-end'>{obj?.maxCtc ?? '-'}</td>
                            <td>
                              <div className='d-flex justify-content-center flex-shrink-0'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1'
                                  onClick={() => {
                                    document.getElementById('bandName')?.focus()
                                    getBandById(
                                      obj.id,
                                      inputField,
                                      setInputField,
                                      setEditId,
                                      setInputError
                                    )
                                    setIsEditModalOpen(true)
                                    setIsAddUserModalOpen(true)
                                  }}
                                >
                                  <i className='far fa-edit'></i>
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                                  onClick={() =>
                                    deleteBand(
                                      obj.id,
                                      getBand,
                                      setBand,
                                      setAPIStatus,
                                      cancelSubmit,
                                      setInputField,
                                      initialState,
                                      setEditId,
                                      setInputError
                                    )
                                  }
                                >
                                  <i className='fa fa-trash'></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={6}>
                            <Center>No Record Available.</Center>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Band
